import { connect } from '../../../common/components/runtime-context';
import { REDUCERS } from '../../../common/components/runtime-context/reducers';
import SearchResultsList from '../../components/search-results-list';
import { getIsSearchLoading } from '../../selectors/is-loading-selectors';
import {
  getSearchResultsCurrentPage,
  getSearchResultsTotal,
} from '../../selectors/search-selectors';
import { getIsMobile } from '../../../common/store/basic-params/basic-params-selectors';

const mapRuntimeToProps = (state, ownProps, actions) => ({
  onPostLikeClick: actions.incrementPostLikeCount,
  onCommentLikeClick: actions.incrementCommentLikeCount,
  isLoading: getIsSearchLoading(state),
  search: pagination => {
    actions.setIsLoading('search', '', true);
    actions.search({ query: ownProps.query, pagination });
  },
  searchResultsTotal: getSearchResultsTotal(state),
  page: getSearchResultsCurrentPage(state, getIsMobile(state)),
});

export default connect(mapRuntimeToProps, [
  REDUCERS.IS_LOADING,
  REDUCERS.SEARCH,
  REDUCERS.BASIC_PARAMS,
])(SearchResultsList);
